var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-checkbox',{staticClass:"column is-12",attrs:{"size":"is-small","native-value":"default"}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.field.properties.basic.rawText)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }